import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from '../locales/en/translation.json';
import esTranslation from '../locales/es/translation.json';

// Define available languages
export const languages = {
  en: { nativeName: 'English', flag: '🇺🇸' },
  es: { nativeName: 'Español', flag: '🇪🇸' }
};

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      es: {
        translation: esTranslation
      }
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false // React already safes from XSS
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Function to change the language
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
  // Save the language preference to localStorage
  localStorage.setItem('i18nextLng', lng);
};

// Function to get the current language
export const getCurrentLanguage = () => {
  return i18n.language || 'en';
};

export default i18n; 